module.exports = __webpack_public_path__ + "static/img/kitchener1.1e72b57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/kitchener1.jpg
// module id = 99
// module chunks = 9